// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"bMTty":[function(require,module,exports) {
require("138b73118a824979").register(JSON.parse('{"18hg5":"login.6d3e88df.js","k04Fc":"user.63573a06.svg","ckW5F":"index.919a24ef.js","ikhXE":"index.36bc93d7.js"}'));

},{"138b73118a824979":"fyJL2"}],"fyJL2":[function(require,module,exports) {
"use strict";
var mapping = {};
function register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)mapping[keys[i]] = pairs[keys[i]];
}
function resolve(id) {
    var resolved = mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"4DmIA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _database = require("firebase/database");
var _config = require("./config");
var _common = require("./common");
var _auth = require("firebase/auth");
var _storage = require("firebase/storage");
var _userSvg = require("../images/user.svg");
var _userSvgDefault = parcelHelpers.interopDefault(_userSvg);
let user;
let auth;
let search;
let step;
let dvLogin, dvRegister, dvProfile, dvWelBack, dvAuth, dvErrorModal, pErrorMsg, dvEmailModal, dvLoaderModal, pLoaderMsg;
let inEmail, inName, inImg, inNewPw, inCurrentPw, inAuthPw;
let ivImg;
let btnLoginCont, btnRegCont, btnRegChangeEmail, btnChangeImg, btnCreateProfile, btnWelCont, btnWelChangeEmail, btnWelForgotPw, btnAuthConfirm, btnAuthForgotPw, btnErrorOk, btnEmailOk;
let email, pw, name;
let dbLink;
let rememberMe = true;
let chkWelRemember, chkRegRemember;
$(document).ready(function() {
    $(function() {
        getExtras();
        initUi();
        initUser();
    });
});
function getExtras() {
    search = window.location.search;
}
function initUi() {
    dvLogin = document.getElementById("dvLogin");
    dvRegister = document.getElementById("dvRegister");
    dvProfile = document.getElementById("dvProfile");
    dvWelBack = document.getElementById("dvWelBack");
    dvAuth = document.getElementById("dvAuth");
    dvErrorModal = document.getElementById("dv-error-modal");
    dvEmailModal = document.getElementById("dv-email-modal");
    dvLoaderModal = document.getElementById("dv-loader-modal");
    pLoaderMsg = dvLoaderModal.querySelector("p");
    pErrorMsg = document.getElementById("p-error-msg");
    ivImg = dvProfile.querySelector("img");
    inEmail = document.getElementById("inEmail");
    inName = document.getElementById("inName");
    inImg = document.getElementById("inImg");
    inNewPw = dvRegister.querySelector("input");
    inCurrentPw = dvWelBack.querySelector("input");
    inAuthPw = dvAuth.querySelector("input");
    chkRegRemember = document.getElementById("chk-reg-remember");
    chkWelRemember = document.getElementById("chk-wel-remember");
    btnLoginCont = dvLogin.querySelector("button");
    btnRegCont = dvRegister.querySelector("button.btn-green-shw");
    btnRegChangeEmail = dvRegister.querySelector("button.btn-white-gray");
    btnChangeImg = document.getElementById("btnChangeImg");
    btnCreateProfile = document.getElementById("btn-create-profile");
    console.log("====================================");
    console.log("checking: button is: " + btnCreateProfile);
    console.log("====================================");
    btnWelCont = dvWelBack.querySelector("button.btn-green-shw");
    btnWelChangeEmail = dvWelBack.querySelector("button.btn-white-gray");
    btnWelForgotPw = dvWelBack.querySelector("button.btn-pw");
    btnAuthConfirm = dvWelBack.querySelector("button.btn-green-shw");
    btnAuthForgotPw = dvAuth.querySelector("button.btn-pw");
    btnErrorOk = dvErrorModal.querySelector("button");
    btnEmailOk = dvEmailModal.querySelector("button");
    step = dvLogin;
}
function initUser() {
    //if user signed in but no info--> finish setting up your account profile ui
    auth = (0, _config.initAuth);
    let gotUser = false;
    (0, _auth.onAuthStateChanged)(auth, (data)=>{
        user = data;
        if (user) {
            console.log("====================================");
            console.log("checking: user logged");
            console.log("====================================");
            checkUserInfo(user.uid);
        } else {
            console.log("====================================");
            console.log("checking: user not logged");
            console.log("====================================");
            initLs();
            inEmail.focus();
        }
    });
//user = auth.currentUser;
}
function initLs() {
    $(chkRegRemember).on("click", function() {
        rememberMe = chkRegRemember.checked;
    });
    $(chkWelRemember).on("click", function() {
        rememberMe = chkRegRemember.checked;
    });
    $(btnLoginCont).on("click", function() {
        checkEmail(inEmail.value.trim());
    });
    $(btnRegCont).on("click", function() {
        verifyNewPw();
    });
    $(btnRegChangeEmail).on("click", function() {
        setStep(dvLogin);
        inEmail.focus();
    });
    $(btnChangeImg).on("click", function() {
        inImg.click();
    });
    $(btnCreateProfile).on("click", function() {
        console.log("====================================");
        console.log("checking: button  create profile clicked");
        console.log("====================================");
        validateName();
    });
    inImg.addEventListener("change", function() {
        if (this.files && this.files[0]) ivImg.src = URL.createObjectURL(this.files[0]); // set src to blob url
        else ivImg.src = (0, _userSvgDefault.default);
    });
    $(btnWelCont).on("click", function() {
        verifyPw(inCurrentPw.value.trim());
    });
    $(btnWelChangeEmail).on("click", function() {
        setStep(dvLogin);
        inEmail.focus();
    });
    $(btnWelForgotPw).on("click", function() {
        sendResetPw();
    });
    $(btnAuthConfirm).on("click", function() {
        reAuthUser();
    });
    $(btnAuthForgotPw).on("click", function() {
        sendResetPw();
    });
    $(btnErrorOk).on("click", function() {
        showErrorModal(false, null);
    });
    $(btnEmailOk).on("click", function() {
        showEmailModal(false);
    });
}
function reAuthUser() {
    //used if need to re-verify user's account (user forgot to create profile)
    pw = inAuthPw.value.trim();
    if (pw) {
        showError(dvAuth, false);
        let credential = (0, _auth.EmailAuthProvider).credential(email, pw);
        (0, _auth.reauthenticateWithCredential)(user, credential).then(()=>{}).catch((_e)=>{
            showErrorModal(true, "Sorry, we could not verify your account");
        });
    } else {
        showError(dvAuth, true);
        (0, _common.shake)(inAuthPw);
    }
}
function showErrorModal(show, msg) {
    (0, _common.setDisplay)(dvErrorModal, show ? "flex" : "none");
    pErrorMsg.textContent = msg ? msg : "Something went wrong. Please try again later.";
}
function sendResetPw() {
    (0, _auth.sendPasswordResetEmail)(auth, email).then(()=>{
        showEmailModal(true);
    }).catch((_e)=>{
        showErrorModal(true, "Could not send email to reset your password");
    });
}
function showEmailModal(show) {
    (0, _common.setDisplay)(dvEmailModal, show ? "flex" : "none");
}
function validateName() {
    showLoader(true, "Verifying name");
    name = inName.value.trim();
    if (name && (0, _common.getIsNameValid)(name)) {
        showError(dvProfile, false);
        checkNameAvailable();
    } else {
        showLoader(false, null);
        showError(dvProfile, true);
        (0, _common.shake)(inName);
    }
}
function checkNameAvailable() {
    showLoader(true, "Checking name availability");
    dbLink = (0, _database.ref)((0, _config.db), `uLink/${name}`);
    (0, _database.onValue)(dbLink, (data)=>{
        if (data.exists()) {
            showLoader(false, null);
            showErrorModal(true, `The name, ${name}, is already in use. Please provide a different name`);
            inName.select();
        } else if (inImg.files[0]) {
            showLoader(true, "Uploading profile image");
            uploadImage(inImg.files[0]);
        //storageRef.put(inImg.files[0]);
        } else uploadProfile(null);
    }, {
        onlyOnce: true
    });
}
function uploadImage(imgFile) {
    const stImg = (0, _database.ref)((0, _config.storage), `user/${user.uid}/img`);
    const task = (0, _storage.uploadBytesResumable)(stImg, imgFile);
    task.on("state_changed", (data)=>{
        const progress = data.bytesTransferred / data.totalBytes * 100;
        showLoader(true, `Uploading profile image: ${progress}`);
    }, (_error)=>{
        showLoader(false, null);
        showErrorModal(true, "Could not upload image. Remove image or try again");
    }, ()=>{
        //success
        (0, _storage.getDownloadURL)(task.snapshot.ref).then((url)=>{
            uploadProfile(url);
        });
    });
}
function uploadProfile(imgUrl) {
    showLoader(true, "Updating your profile");
    const profile = {
        name: name,
        lcName: name.toLowerCase(),
        img: imgUrl ? "blob" : null,
        imgUrl: imgUrl ? imgUrl : null,
        uid: user.uid,
        guest: false,
        guestId: (0, _common.getGuestId)(),
        date: new Date().getTime()
    };
    let dbUser = (0, _database.ref)((0, _config.db), `user/${user.uid}`);
    (0, _database.set)(dbUser, profile).then(()=>{
        //TODO: in future, update firebase profile
        showLoader(true, "Creating profile link");
        (0, _database.set)(dbLink, user.uid).finally(()=>{
            (0, _database.set)((0, _database.ref)((0, _config.db), `uSearch/${user.uid}`), profile.lcName).finally(()=>{
                showLoader(false, null);
                showWelcomeDialog();
            });
        });
    }).catch((_e)=>{
        showErrorModal(true, "Could not create your profile at this time. Try again later.");
    });
}
function showWelcomeDialog() {
    let dvWelcomeMod = document.getElementById("dv-welcome-modal");
    let btnHome = dvWelBack.querySelector("button");
    $(btnHome).on("click", function() {
        initRedirect();
    });
    (0, _common.setDisplay)(dvWelcomeMod, "flex");
    let cx = 3;
    const x = setInterval(function() {
        btnHome.innerHTML = `Go home (${cx--})`;
        if (cx < 0) {
            clearInterval(x);
            initRedirect();
        }
    }, 1000);
}
function verifyNewPw() {
    showLoader(true, "Verifying password");
    pw = inNewPw.value.trim();
    if (pw) {
        showError(dvRegister, false);
        registerUser();
    } else {
        showLoader(false, null);
        showError(dvRegister, true);
        (0, _common.shake)(inNewPw);
    }
}
function registerUser() {
    showLoader(true, "Creating your account");
    setLoginPersistance();
    (0, _auth.createUserWithEmailAndPassword)(auth, email, pw).then((userCredential)=>{
        showLoader(false, null);
        user = userCredential.user;
        setStep(dvProfile);
        inName.focus();
    }).catch((e)=>{
        showLoader(false, null);
        showErrorModal(true, "Could not create your account. Try again later.");
    });
}
function verifyPw(p) {
    showLoader(true, "Verifying password");
    pw = p;
    if (pw) {
        showError(dvWelBack, false);
        loginUser();
    } else {
        showLoader(false, null);
        showError(dvWelBack, true);
        (0, _common.shake)(inCurrentPw);
    }
}
function loginUser() {
    showLoader(true, "Signing you in");
    setLoginPersistance();
    (0, _auth.signInWithEmailAndPassword)(auth, email, pw).then((userCredential)=>{
        showLoader(false, null);
        user = userCredential.user;
    //checkUserInfo(user.uid);
    }).catch((error)=>{
        showLoader(false, null);
        showErrorModal(true, "Could not login into your account");
    });
}
function setLoginPersistance() {
    (0, _auth.setPersistence)(auth, rememberMe ? (0, _auth.browserLocalPersistence) : (0, _auth.browserSessionPersistence));
}
function checkEmail(nEmail) {
    showLoader(true, "Checking email");
    email = nEmail;
    if (email) {
        if ((0, _common.getIsEmailValid)(email)) {
            showError(dvLogin, false);
            checkEmailAccount(email);
        } else {
            showLoader(false, null);
            showError(dvLogin, true);
            (0, _common.shake)(inEmail);
        }
    } else {
        showLoader(false, null);
        showError(dvLogin, true);
        (0, _common.shake)(inEmail);
    }
}
function checkEmailAccount(email) {
    (0, _auth.fetchSignInMethodsForEmail)(auth, email).then((signInMethods)=>{
        showLoader(false, null);
        if (signInMethods && signInMethods.length > 0) {
            setStep(dvWelBack);
            inCurrentPw.focus();
        } else {
            setStep(dvRegister);
            inNewPw.focus();
        }
    }).catch((_error)=>{
        showLoader(false, null);
        showErrorModal(true, "Something went wrong. Try again later.");
    });
}
function showError(e, isShow) {
    let dError = e.querySelector(".d-error");
    (0, _common.setDisplay)(dError, isShow ? "flex" : "none");
}
function checkUserInfo(uid) {
    let dbUser = (0, _database.ref)((0, _config.db), `uSearch/${uid}`);
    (0, _database.onValue)(dbUser, (data)=>{
        if (data.exists()) initRedirect();
        else {
            setStep(dvProfile);
            inName.focus();
            initLs();
        }
    }, {
        onlyOnce: true
    });
}
function showLoader(show, msg) {
    (0, _common.setDisplay)(dvLoaderModal, show ? "flex" : "none");
    pLoaderMsg.textContent = msg ? msg : "uploading data";
}
function setStep(e) {
    (0, _common.setDisplay)(step, "none");
    (0, _common.setDisplay)(e, "flex");
    step = e;
}
function initRedirect() {
    let loc = `../index.html${search}`;
    let action = search.substring(search.indexOf("?"), search.indexOf("="));
    if (action == "?g") {
        search = search.replace("?g=", "?");
        loc = `../group.html${search}`;
    } else if (search.includes("?action=remove")) loc = `../removeAccount.html?action=success`;
    window.location.replace(loc);
}

},{"firebase/database":"gGruC","./config":"cl3hM","./common":"loJev","firebase/auth":"8Nm6e","firebase/storage":"5lcfA","../images/user.svg":"aWC4G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aWC4G":[function(require,module,exports) {
module.exports = require("b2c4dd8eb269ac6a").getBundleURL("18hg5") + require("8b981c0496f6b63e").resolve("k04Fc");

},{"b2c4dd8eb269ac6a":"c7Tr5","8b981c0496f6b63e":"fyJL2"}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["bMTty","4DmIA"], "4DmIA", "parcelRequiref9e4")

//# sourceMappingURL=login.6d3e88df.js.map
